import {
  GET_NOTATION_HEADER,
  GET_NOTATION_RAW,
  GET_NOTATION_WXR,
  GET_JOURNALIST_BONUS,
  UPDATE_JOURNALIST_BONUS,
  GET_NOTATION_COMPARE,
  GET_NOTATION_HEADER_COMPARE,
  GET_NOTATION_COMPARE_ADDITIONAL_RIVALS
} from '../constants/notes';

import {
  fetchNotationHeader,
  fetchNotationRaw,
  fetchNotationWxr,
  fetchJournalistBonus,
  insertJournalistBonus,
  fetchNotationCompare,
  fetchNotationHeaderCompare
} from '../api/notes';

export const getNotationHeader = () => async (dispatch) => {
  const data = await fetchNotationHeader();
  dispatch({
    type: GET_NOTATION_HEADER,
    payload: data
  });
};

export const getNotationHeaderCompare = () => async (dispatch) => {
  const data = await fetchNotationHeaderCompare();
  dispatch({
    type: GET_NOTATION_HEADER_COMPARE,
    payload: data
  });
};

export const getNotationRaw = () => async (dispatch) => {
  const data = await fetchNotationRaw();
  dispatch({
    type: GET_NOTATION_RAW,
    payload: data
  });
};

export const getNotationWxr = (options) => async (dispatch) => {
  const data = await fetchNotationWxr(options || {});
  dispatch({
    type: GET_NOTATION_WXR,
    payload: data
  });
};

export const getNotationCompare = (options) => async (dispatch) => {
  const data = await fetchNotationCompare(options || {});
  dispatch({
    type: GET_NOTATION_COMPARE,
    payload: data
  });
};

export const getNotationCompareAdditionalRivals =
  (options) => async (dispatch) => {
    let data = {};
    if (
      (options.rank && options.rank.length > 0) ||
      (options.appellation && options.appellation.length > 0)
    ) {
      data = await fetchNotationCompare(options || {});
    }
    dispatch({
      type: GET_NOTATION_COMPARE_ADDITIONAL_RIVALS,
      payload: data
    });
  };

export const getJournalistBonus = () => async (dispatch) => {
  const data = await fetchJournalistBonus();
  dispatch({
    type: GET_JOURNALIST_BONUS,
    payload: data
  });
};

export const postJournalistBonus = (data) => async (dispatch) => {
  const result = await insertJournalistBonus(data);
  dispatch({
    type: UPDATE_JOURNALIST_BONUS,
    payload: result
  });
};
